<template>

	<div class="zichanyingshou">

		<div class="top-spacer"></div>

		<div class="zichanyingshou-t">

			<div

				v-for="item in datalist"

				:key="item.id"

				class="list-item"

				:class="{ 'list-item--clickable': item.id === 'equity' }"

			>

				<div class="decoration-wrap">

					<img src="../../../assets/透明底.png" class="title-img decoration-icon" alt="" />

					<dv-decoration-9 style="width:100px;height:100px">

						<div class="list-top">

							<div class="title-type">

								<div v-for="(line, i) in item.titleLines" :key="i">{{ line }}</div>

							</div>

						</div>

					</dv-decoration-9>

				</div>

				<div

					class="list-bottom"

					:class="{ 'list-bottom--equity': item.id === 'equity' }"

					@click="item.id === 'equity' && openEquityDetailPopup()"

				>

					<dv-border-box-12>

						<div class="box">

							<div class="title-name">{{ item.name }}</div>

							<div class="num-wrap">

								<div class="list-text-item-num">{{ item.num }}</div>

								<div class="title-name">{{ item.danwei }}</div>

							</div>

						</div>

					</dv-border-box-12>

				</div>

			</div>

		</div>



		<!-- 股权收益明细弹窗（与同兴长投收益一致） -->
		<div
			v-if="equityPopupVisible"
			class="equity-detail-popup dashboard-chart-popup dashboard-chart-popup--medium"
			v-append-to-body
		>
			<div class="popup-head">
				<div class="popup-dot"></div>
				<span class="popup-head-text">股权收益明细</span>
				<el-button @click="equityPopupVisible = false" type="text" icon="el-icon-circle-close" />
			</div>
			<div class="popup-company">山东省金融资产管理有限公司股权分红情况</div>
			<div class="popup-sub">被投资方：{{ equityCompany }}</div>
			<el-table
				:data="tongxingIncomeRecords"
				stripe
				:border="false"
				style="width:100%;background-color:#071a52;"
				height="240"
			>
				<el-table-column prop="year" label="年份" width="90" align="center" />
				<el-table-column prop="income" label="投资收益（万元）" align="center" />
			</el-table>
		</div>

	</div>

</template>



<script>

	import apis from '@/http/apis';

	import { calcTongxingIncomeTotal, mapManagedGroupIncomeRecords } from './tongxing-changtou-data';



	export default {

		name: 'RingChart',

		data() {

			return {

				datalist: [

					{ id: 'stock', titleLines: ['存量资产'], name: '累计营收', num: '--', danwei: '万元' },

					{ id: 'npa', titleLines: ['不良资产', '债权总额'], name: '债权总额', num: '--', danwei: '万元' },

					{ id: 'equity', titleLines: ['股权资产'], name: '股权收益', num: '--', danwei: '万元' },

				],

				equityIncomeTotal: '0.00',
				equityPopupVisible: false,
				equityCompany: '山东省金融资产管理股份有限公司',
				tongxingIncomeRecords: [],

			};

		},

		created() {

			this.fetchData();

		},

		mounted() {

			if (this.$bus) {

				this.$bus.$on('tongxing-income-updated', this.onTongxingIncomeUpdated);

			}

		},

		beforeDestroy() {

			if (this.$bus) {

				this.$bus.$off('tongxing-income-updated', this.onTongxingIncomeUpdated);

			}

		},

		methods: {

			onTongxingIncomeUpdated(records) {
				const list = records && records.length ? records : [];
				this.tongxingIncomeRecords = [...list];
				this.equityIncomeTotal = calcTongxingIncomeTotal(list);
				// 注意：不再调用 updateEquityNum()
				// 股权收益卡片的显示数字现在由 kpiConfig 接口管控，
				// 此处只更新内部明细记录（供弹窗/详情展示使用）
			},

			updateEquityNum() {

				const idx = this.datalist.findIndex((item) => item.id === 'equity');

				if (idx < 0) return;

				this.$set(this.datalist, idx, {

					...this.datalist[idx],

					num: this.equityIncomeTotal,

				});

			},

			fetchData() {

				Promise.all([
					apis.assetRevenue().catch((err) => {
						console.error('资产营收接口请求失败', err);
						return {};
					}),
					apis.managedGroupEquityIncomeDetail().catch((err) => {
						console.error('代管集团投资股权收益接口请求失败', err);
						return {};
					}),
					apis.kpiConfig().catch((err) => {
						console.error('KPI配置接口请求失败', err);
						return {};
					}),
				]).then(([revenueRes, incomeRes, kpiRes]) => {

					const d = revenueRes && revenueRes.data ? revenueRes.data : {};
					const incomeList = incomeRes && incomeRes.data && incomeRes.data.list ? incomeRes.data.list : [];
					this.tongxingIncomeRecords = mapManagedGroupIncomeRecords(incomeList);
					this.equityIncomeTotal = calcTongxingIncomeTotal(this.tongxingIncomeRecords);
					// 从 kpiConfig 接口提取三个底部卡片的可调整值
					const kpiList = (kpiRes && kpiRes.data && kpiRes.data.list) ? kpiRes.data.list : [];
					const kpiMap = {};
					kpiList.forEach(item => { kpiMap[item.fieldKey] = item.fieldValue; });

					this.datalist = [

						{

							id: 'stock',

							titleLines: ['存量资产'],

							name: '累计营收',

							num: kpiMap['stock_asset_revenue'] != null ? Number(kpiMap['stock_asset_revenue']).toFixed(2) : '--',

							danwei: '万元',

						},

						{

							id: 'npa',

							titleLines: ['不良资产', '债权总额'],

							name: '债权总额',

							num: kpiMap['claims_total'] != null ? Number(kpiMap['claims_total']).toFixed(2) : '--',

							danwei: '万元',

						},

						{

							id: 'equity',

							titleLines: ['股权资产'],

							name: '股权收益',

							num: kpiMap['equity_income'] != null ? Number(kpiMap['equity_income']).toFixed(2) : '--',

							danwei: '万元',

						},

					];

				});

			},

			openEquityDetailPopup() {
				this.equityPopupVisible = true;
				if (this.$bus) {
					this.$bus.$emit('close-map-marker');
				}
			},

		},

	};

</script>



<style scoped>

	.zichanyingshou {

		width: 100%;

		height: 100%;

		border-radius: 20px;

		background: linear-gradient(0deg, hsla(0, 0%, 100%, 0.2) 20%, hsla(0, 0%, 100%, 0));

		display: flex;

		flex-direction: column;

	}



	.top-spacer {

		height: 50px;

		flex-shrink: 0;

	}



	.zichanyingshou-t {

		flex: 1;

		min-height: 0;

		width: 100%;

		display: flex;

		justify-content: space-around;

	}



	.list-item {

		width: 30%;

		height: 100%;

		display: flex;

		flex-direction: column;

		align-items: center;

	}



	.decoration-wrap {

		position: relative;

		width: 100px;

		height: 100px;

		flex-shrink: 0;

	}



	.decoration-icon {

		position: absolute;

		left: 50%;

		top: 0;

		transform: translate(-50%, -50%);

		margin-right: 0;

		z-index: 2;

		pointer-events: none;

	}



	.list-item--clickable .list-bottom--equity {

		cursor: pointer;

	}



	.list-item--clickable .list-bottom--equity:hover ::v-deep .dv-border-box-12 {

		filter: brightness(1.15);

	}



	.list-bottom {

		width: 100%;

		height: calc(100% - 100px);

	}



	.dv-border-box-12 {

		margin-top: 10%;

		padding: 10px 20px;

		width: calc(100% - 40px);

		height: calc(90% - 35px);

	}



	.box {

		height: 100%;

		width: 100%;

		display: flex;

		flex-direction: column;

		justify-content: center;

		gap: 5%;

		align-items: center;

	}



	.title-name {

		font-size: 2vh;

		color: #07e1ff;

		display: flex;

		align-items: center;

		gap: 2px;

		font-weight: 500;

	}



	.list-text-item-num {

		font-size: 2vh;

		font-weight: 700;

		color: #fff;

		word-break: break-all;

		text-align: center;

	}



	.num-wrap {

		display: flex;

		flex-direction: column;

		align-items: center;

		gap: 2px;

	}



	.title-type {

		width: calc(100% - 10px);

		margin: 5px;

		font-size: 1.6vh;

		color: #ffffff;

		font-weight: 600;

		display: flex;

		flex-direction: column;

		align-items: center;

		justify-content: center;

		text-align: center;

		line-height: 1.4;

	}



	.title-img {

		height: 30px;

		margin-right: 5px;

	}



	/* 弹窗 */

	.popup-head {

		margin: 10px;

		color: #ffffff;

		font-size: 14px;

		font-weight: 600;

		display: flex;

		align-items: center;

		gap: 5px;

		position: relative;

	}



	.popup-dot {

		width: 14px;

		height: 14px;

		border-radius: 50%;

		background-color: #f56c6c;

		flex-shrink: 0;

	}



	.popup-head-text {

		flex: 1;

		line-height: 1.35;

	}



	.equity-detail-popup ::v-deep .el-icon-circle-close {

		position: absolute;

		right: 0;

		top: 50%;

		transform: translateY(-50%);

		font-size: 20px;

		color: #fff;

	}



	.popup-company {
		margin: 0 10px 4px;
		font-size: 13px;
		color: #e8f4ff;
		font-weight: 600;
	}

	.popup-sub {
		margin: 0 10px 8px;
		font-size: 12px;
		color: #8ab4d4;
	}

	.equity-detail-popup ::v-deep .el-table tr {

		color: #fff !important;

		background-color: #071a52 !important;

	}



	.equity-detail-popup ::v-deep .el-table th.el-table__cell {

		color: #fff !important;

		background-color: #3c4a77 !important;

	}



	.equity-detail-popup ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {

		background-color: #0d2569 !important;

	}



	.equity-detail-popup ::v-deep .el-table__cell {

		padding: 5px 0 !important;

		font-size: 12px;

		border-bottom: none !important;

	}



	.equity-detail-popup ::v-deep .el-table::before {

		height: 0;

	}

</style>


